import { useAuth } from '@tom-ui/utils'
import { Avatar, Menu, MenuItem } from '@mui/material'
import { useNavigationStore } from '@planning/stores'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useState } from 'react'

export const HeaderAvatar = () => {
  const { logout, user, isAuthenticated } = useAuth()
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const navigationStore = useNavigationStore()

  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const onHomeClick = () => {
    navigationStore.clear()
    handleClose()
  }

  const avatarInitials = user?.name
    ?.split(' ')
    .map(word => word.charAt(0))
    .join('')

  return (
    <>
      <Avatar
        id='logout-menu'
        sx={{ bgcolor: theme.palette.grey[400], cursor: 'pointer', fontSize: '0.9rem' }}
        onClick={handleClick}
      >
        {avatarInitials}
      </Avatar>

      <Menu id='logout-menu' anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={onHomeClick}>{t('home', 'Home')}</MenuItem>
        <MenuItem
          onClick={async () => {
            logout({ logoutParams: { returnTo: window.location.origin } })
          }}
        >
          {t('logout', 'Logout')}
        </MenuItem>
      </Menu>
    </>
  )
}
